import {
  REQUEST_TAG_USERS,
  FAIL_RECEIVE_TAG_USERS,
  RECEIVE_TAG_USERS,
  FINISHED_TAG_USERS,
} from 'shared/actionTypes';

function users(state = [], action) {
  switch (action.type) {
  case RECEIVE_TAG_USERS:
    const { users: nextUsers } = action.payload;
    return [
      ...state,
      ...nextUsers,
    ];
  default:
    return state;
  }
}

function tagDetails(state = {
  isError: false,
  isFetching: false,
  isFinished: false,
  lastUserTagId: null,
  users: [],
}, action) {
  switch (action.type) {
  case REQUEST_TAG_USERS:
    return Object.assign({}, state, {
      isFetching: true,
    });
  case FAIL_RECEIVE_TAG_USERS:
    return Object.assign({}, state, {
      isError: true,
      isFetching: false,
    });
  case RECEIVE_TAG_USERS:
    const { lastUserTagId } = action.payload;
    return Object.assign({}, state, {
      isFetching: false,
      lastUserTagId,
      users: users(state.users, action),
    });
  case FINISHED_TAG_USERS:
    return Object.assign({}, state, {
      isFinished: true,
    });
  default:
    return state;
  }
}

export default function contentTagDetails(state = {}, action) {
  switch (action.type) {
  case REQUEST_TAG_USERS:
  case FAIL_RECEIVE_TAG_USERS:
  case RECEIVE_TAG_USERS:
  case FINISHED_TAG_USERS:
    const { communityContentType, communityContentRelatedId } = action.payload;
    const communityContentIdKey = `${communityContentType}-${communityContentRelatedId}`;
    const { tagDetails: previousTagDetails } = state[communityContentIdKey] || {};

    return Object.assign({}, state, {
      [communityContentIdKey]: {
        tagDetails: tagDetails(previousTagDetails, action),
      },
    });
  default:
    return state;
  }
}
